import React, {useEffect, useState} from 'react';
import * as Icons from "./icons";
import {Avatar} from "primereact/avatar";
import {Divider} from "primereact/divider";
import Config from "./config";
import {types as userTypes, useUser} from "./auth/UserContext";
import {types, useSidebar} from "./SidebarContext";
import UserProfileDialog from "./dialogs/UserProfileDialog";
import {Dropdown} from "primereact/dropdown";
import {useStorage} from "./hooks/useStorage";

function UserDropdown(){
    const user = useUser();
    const [expanded, setExpanded] = useState(false);
    const [showProfileDialog, setShowProfileDialog] = useState(false);
    const {setUser} = useStorage();
    const userDropdownItems = [
        {
            label:Config.glossary.userID,
            value:"13245789"
        },
        {
            label:Config.glossary.userManagement,
            icon:<Icons.Person/>,
            command:()=>{setShowProfileDialog(true)}

        },
        {
            label:Config.glossary.signOut,
            icon:<Icons.SignOut/>,
            command:()=>{user.logout()}
        },
    ]
    let companies = [{accountid:-1, Name:"همه شرکت ها"}];
    companies = companies.concat(user.state.userData.companies);
    const [currentCompany, setCurrentCompany] = useState(user.state.userData.companies && user.state.userData.companies.length>0 ? companies.find(c=>c.accountid===user.state.userData.customerid || c.AccountId===user.state.userData.customerid):undefined);


    useEffect(()=>{

        companies.find(c=>c.AccountId===user.state.userData.account.AccountId)
        // console.log(user.state.userData, companies, currentCompany);
    },[currentCompany])

    return(
        <>
            <div className="flex gap-3 relative">
                <div className="w-18rem">
                    <div className={`bg-white border-round-xl flex flex-column shadow-2 top-0 z-5 ${Config.glossary.dir==="rtl"?"left-0":"right-0"} transition-duration-300 transition-all w-18rem absolute overflow-hidden ${!expanded?'h-4rem':user.state.userData.companies && user.state.userData.companies.length>0?'h-19rem':'h-15rem'}`} onMouseLeave={()=>{setExpanded(false)}} >
                        <div className="flex p-2 pb-0 justify-content-between align-items-center cursor-pointer " onClick={()=>{setExpanded(!expanded)}}>
                            <div className="flex gap-2 align-items-center">
                                {user.state.userData.entityimage?(<img className="border-round-md w-3rem h-3rem bg-gray-100" src={`data:image/jpeg;base64,${user.state.userData.entityimage}`}/>):(<img className="border-round-md w-3rem h-3rem bg-gray-100"/>)}

                                <div className="flex flex-column">
                                    <span className="font-bold">{user.state.userData.fullname}</span>
                                    <span className="text-gray-500 english-font ltr">{user.state.userData.mobilephone}</span>
                                </div>
                            </div>
                            <span className={`${Config.glossary.dir==="rtl"?"pl-3":"pr-3"} pi pi-chevron-${expanded?"up":"down"}`}/>
                        </div>
                        {
                            user.state.userData.companies && user.state.userData.companies.length>0 && (
                                <div className="p-2">
                                    <Dropdown className="w-full shadow-none" options={companies} disabled={user.state.userData.companies.length===1} optionLabel="Name" value={currentCompany} itemTemplate={(item, options)=>(<div className="text-right">{item.Name}</div>)} onChange={(e)=>{setCurrentCompany(e.value); let userData = {...user.state.userData, customerid:e.value.accountid?e.value.accountid:e.value.AccountId}; user.dispatch({type:userTypes.SET_USER_DATA, userData}); setUser(userData);}}/>
                                </div>
                            )
                        }

                        <Divider className="mt-2 m-0"/>

                        {
                            userDropdownItems.map(item=>(<DropdownItem label={item.label} icon={item.icon} value={item.value} onClick={item.command}/>))
                        }

                    </div>
                </div>
            </div>
            <UserProfileDialog visible={showProfileDialog} setVisible={setShowProfileDialog}/>
        </>
    )
}

function DropdownItem({label, icon, value, onClick}){
    return(
        <div className={`flex justify-content-between align-items-center p-3 border-top-1 hover:bg-gray-100 border-gray-300 ${onClick && "cursor-pointer"}`} onClick={onClick}>
            <span className="flex align-items-center gap-2">
                {icon}
                <span>{label}</span>
            </span>
            {
                onClick &&(<span className={`pi pi-chevron-${Config.glossary.dir==="rtl"?"left":"right"}`}/>)
            }
            {
                value && (<span >{value}</span>)
            }
        </div>
    )
}

function Menubar() {

    const sidebar = useSidebar();
    return (
        <div>
            <div className="flex flex-column flex-column-reverse lg:flex-row lg:justify-content-between ">
                <div>
                    <span className="block yekan-bakh-font text-2xl">{Config.glossary[sidebar.getSelectedItem().title]?Config.glossary[sidebar.getSelectedItem().title].title:sidebar.getSelectedItem().title}</span>
                    <span className="block text-gray-500 text-sm">{Config.glossary[sidebar.getSelectedItem().title]?Config.glossary[sidebar.getSelectedItem().title].description:""}</span>
                </div>
                <UserDropdown/>
            </div>
        </div>
    );
}

export default Menubar;